function getBasePlacement(placement) {
  return placement.split('-')[0];
}

export { getBasePlacement as g };
//# sourceMappingURL=getBasePlacement-670cde36.js.map
